import { useI18n } from 'vue-i18n'

export type CampoNovita = 'titolo' | 'breve' | 'lungo' | 'pulsante'

/** Percorso interno dell'app: una sola barra iniziale, nessuno schema né host (difesa in più rispetto al server). */
export function percorsoInterno(valore: string | null | undefined): string | null {
  if (!valore || !valore.startsWith('/') || valore.startsWith('//') || /[\s\\]/.test(valore)) return null
  return valore
}

/** Un testo semplice in paragrafi (separati da una riga vuota): mai HTML, si mostra con l'interpolazione. */
export function paragrafi(testo: string | null | undefined): string[] {
  if (!testo) return []
  return testo.split(/\n{2,}/).map((p) => p.trim()).filter(Boolean)
}

/**
 * Il testo di un annuncio nella lingua dell'utente: la traduzione `novita.<chiave>.<campo>` se esiste, altrimenti il testo
 * italiano scritto nell'annuncio. Il testo italiano NON passa da `t(chiave, predefinito)`: il predefinito è compilato come
 * messaggio i18n e un testo libero con `{` o `|` lo romperebbe.
 */
export function useTestiNovita() {
  const { t, te } = useI18n()
  function testo(chiave: string | undefined, campo: CampoNovita, italiano: string | null | undefined): string {
    const k = `novita.${chiave ?? ''}.${campo}`
    if (chiave && te(k)) return t(k)
    return italiano ?? ''
  }
  return { testo }
}

/** Il solo percorso (senza query né frammento, senza barra finale) per confrontare il link di un annuncio con quello di una voce di menu. */
export function percorsoNormalizzato(valore: string | null | undefined): string | null {
  const p = percorsoInterno(valore)
  if (!p) return null
  const solo = p.split(/[?#]/)[0] ?? ''
  return solo.length > 1 ? solo.replace(/\/+$/, '') : solo
}

/**
 * Percorsi delle voci di menu da marcare «Nuovo»: i link degli annunci Novità ancora da mostrare all'utente (il server ha già
 * applicato interruttore, periodo, destinatari, funzione non attiva per l'azienda e chiusura; qui si tolgono solo quelli chiusi
 * in questa sessione). Nessun id di menu: il collegamento è il link dell'annuncio.
 */
export function percorsiMenuNovita(elenco: ReadonlyArray<{ id?: number; link?: string | null }>, chiusi: ReadonlySet<number>): Set<string> {
  const out = new Set<string>()
  for (const a of elenco) {
    if (a.id != null && chiusi.has(a.id)) continue
    const p = percorsoNormalizzato(a.link)
    if (p) out.add(p)
  }
  return out
}
